<template>
  <div class="monitoringSystem-wrap">
    <el-row :gutter="20" class="box-top">
      <el-col :span="8" class="box-col">
        <div class="gk">
          <general-situation :measureId="measureId"></general-situation>
        </div>
      </el-col>
      <el-col :span="8" class="box-col">
        <div class="yx">
          <run-state></run-state>
        </div>
      </el-col>
      <el-col :span="8" class="box-col">
        <div class="hj">
          <div class="hj-top">
            <environment-state></environment-state>
          </div>
          <div class="hj-bottom">
            <today-alarm></today-alarm>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="box-bottom">
      <el-col :span="16" class="box-col">
        <div class="dj">
          <accumulation></accumulation>
        </div>
      </el-col>
      <el-col :span="8" class="box-col">
        <div class="yd">
          <use-ele></use-ele>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@common/api/index.js'
import GeneralSituation from '@/components/page/monitoring/GeneralSituation.vue'
import RunState from '@/components/page/monitoring/RunState.vue'
import EnvironmentState from '@/components/page/monitoring/EnvironmentState.vue'
import TodayAlarm from '@/components/page/monitoring/TodayAlarm.vue'
import Accumulation from '@/components/page/monitoring/Accumulation.vue'
import UseEle from '@/components/page/monitoring/UseEle.vue'
import gklogo from '@/assets/images/monitoring/companyMsg.png'
import dateTool from '@/utils/dateTool'
import * as utils from '@/utils/index.js'
export default {
  name: 'monitoringSystem',
  // 引用组件
  components: {
    GeneralSituation,
    RunState,
    EnvironmentState,
    TodayAlarm,
    Accumulation,
    UseEle
  },
  data () {
    return {
      gklogo: gklogo,
      measureId: ''
    }
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  created () {
    this.$api.customUrl
      .getFrontEndPageCustomParam(0, '/home/monitoringSystem', null)
      .then(res => {
        let resData = JSON.parse(res.data[0].value)
        this.measureId = resData[0].measureId
      })
  },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    //   this.getRes()
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {}
}
</script>
<style lang="scss" scoped>
.monitoringSystem-wrap {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .box-top {
    height: 48%;
    margin-bottom: 16px;
    .box-col {
      height: 100%;
      color: rgba(79, 83, 0);
      .gk {
        height: 100%;
        border-radius: 4px;
        .logoImg {
          // background-image: url(../../assets/images/monitoring/logo.ico);
          margin-right: 5px;
        }
      }
      .yx {
        height: 100%;
        color: rgba(79, 83, 0);
        border-radius: 4px;
      }
      .hj {
        color: rgba(79, 83, 0);
        height: 100%;
        display: flex;
        flex-flow: column;
        // border-radius: 4px;
        .hj-top {
          height: 45%;
          margin-bottom: 20px;
          // background: #f7f9f8;
          border-radius: 4px;
        }
        .hj-bottom {
          // background: #f7f9f8;
          display: flex;
          flex: 1;
          border-radius: 4px;
        }
      }
    }
  }
  .box-bottom {
    height: 50%;
    .box-col {
      height: 100%;
      color: rgba(79, 83, 0);
      .dj {
        height: 100%;
        // background: rgba(247, 249, 248);
        border-radius: 4px;
      }
      .yd {
        height: 100%;
        border-radius: 4px;
      }
    }
  }
}
</style>